import { useLocation } from 'react-router-dom';

// Ce composant force la position en haut de la page lors d'un changement de route
// sans aucune animation de défilement
export default function SmoothRouteTransition() {
  // eslint-disable-next-line no-unused-vars
  const { pathname } = useLocation();
  
  // Cette technique utilise une propriété spéciale de React Router
  // pour désactiver complètement le comportement de défilement
  if (typeof window !== 'undefined') {
    // Force la position en haut immédiatement lors du changement de route
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0; // Pour Safari
  }
  
  // Ajouter une classe pour l'animation de transition du contenu
  if (typeof document !== 'undefined') {
    const mainContent = document.querySelector('main') || document.body;
    mainContent.classList.add('route-transition');
    
    // Retirer la classe après l'animation
    setTimeout(() => {
      mainContent.classList.remove('route-transition');
    }, 300);
  }

  return null; // Ce composant ne rend rien dans le DOM
}
